module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_5.5b314300.webp";